export enum InspectionConclusionEnum {
  None = "None",
  Passed = "Passed",
  Failed = "Failed",
}

export enum InspectionOtherStandard {
  None = "-",
  HotStamping = "HotStamping",
  Embossing = "Embossing",
  BrailleStamping = "BrailleStamping",
  Special = "Special",
  HotStampingAndBrailleStamping = "HotStampingAndBrailleStamping",
  HotStampingAndEmbossing = "HotStampingAndEmbossing",
  HotStampingAndSpecial = "HotStampingAndSpecial",
  BrailleStampingAndSpecial = "BrailleStampingAndSpecial",
}

export enum PrintColorInspect {
  Standard = "Standard",
  TooDark = "TooDark",
  TooLight = "TooLight",
}

export enum InspectionType {
  Stella = 0,
  DualLang = 1,
}

export enum StorageTemperature {
  ventilated = "ventilated", // Thông thoáng
  StandardTemperature = "StandardTemperature", // Nhiệt độ tiêu chuẩn (23 - 32°C)
}
